// extracted by mini-css-extract-plugin
module.exports = {"component":"NotFound_component__nRrT2","container":"NotFound_container__PScWX"};